/**
 * An app that is active/installed for the current tenant, as returned by
 * `GET /v2/b2b/apps/activeapps`.
 */
export interface ActiveApp {
  /** The app reference id matched against the configured stored value app id. */
  appRefid: string;
  [key: string]: unknown;
}

/**
 * Default app id used to detect the stored value (gift card) app when
 * `window.CONFIG.STORED_VALUE_APP_ID` is not set.
 */
export const DEFAULT_STORED_VALUE_APP_ID = 'stored-value';
